import { api } from "./api";
import { endpoints } from "./endpoints";

export const addBrokerEmailApi = async (payload: {
  teamSchema: string;
  email: string;
}) => {
  return await api.post(endpoints.addBrokerEmail, payload);
};

export const checkBrokerEmailApi = async (payload: {
  email: string;
  teamSchema: string;
}) => {
  return await api.post(endpoints.checkBrokerEmail, payload);
};

export const getZipCodeListsApi = async (payload: { teamSchema: string }) => {
  return await api.post(endpoints.getZipCodeLists, payload);
};

export const addAccountRestrictionApi = (payload: {
  teamSchema: string;
  accountId: string;
  email: string;
  reason: string;
}) => {
  return api.post(endpoints.addAccountRestriction, payload);
};
